// extracted by mini-css-extract-plugin
export default {"categoryItem":"Category_categoryItem__6u0FQ","categoryName":"Category_categoryName__YjGtO"};